<template>
  <!-- partial:partials/_navbar.html -->
  <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row" :class="{ 'navbar-scrolled': navbarScrolled }">
    <div class="navbar-blur-layer"></div>
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
      <a class="navbar-brand brand-logo me-5" href="/"><img src="./../../public/images/logo-mini.png"
          style="width: 40%; height: 100%;" class="me-2 ms-4" alt="logo" /></a>
      <a class="navbar-brand brand-logo-mini" href="/"><img src="./../../public/images/logo-mini.png"
          style="width: 100%; " alt="logo" /></a>
    </div>
    <div  class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
      <button @click="activarSidebarBody()" class="navbar-toggler navbar-toggler align-self-center desktop-sidebar-toggler" type="button">
        <!-- <span class="ti-view-list"></span> -->
        <!-- <span><i class="fa-solid fa-bars"></i></span> -->
        <span><i class="bi bi-list" style="font-size: 40px;"></i></span>
      </button>
      <ul class="navbar-nav mr-lg-2">
        <!-- <li class="nav-item nav-search d-none d-lg-block">
          <div class="input-group">
            <div class="input-group-prepend hover-cursor" id="navbar-search-icon">
              <span class="input-group-text" id="search">
                <i class="ti-search"></i>
              </span>
            </div>
            <input type="text" class="form-control" id="navbar-search-input" placeholder="Search now" aria-label="search"
              aria-describedby="search">
          </div>
        </li> -->
      </ul>
      <div class="navbar-center-message">
        <div class="header-nav-shell">
          <ul class="header-top-nav nav" @scroll="handleHeaderNavScroll">
            <li class="header-nav-item nav-item">
              <router-link class="header-nav-link nav-link" to="/" aria-label="Inicio" :class="{ 'is-active-module': isModuleActive('home') }" @mouseenter="showNavTooltip($event, 'Inicio')" @mouseleave="hideNavTooltip" @focus="showNavTooltip($event, 'Inicio')" @blur="hideNavTooltip">
                <i class="bi bi-house-fill menu-icon"></i>
              </router-link>
            </li>
            <li class="header-nav-item nav-item">
              <router-link class="header-nav-link nav-link" to="/dashboard" aria-label="Dashboard" :class="{ 'is-active-module': isModuleActive('dashboard') }" @mouseenter="showNavTooltip($event, 'Dashboard')" @mouseleave="hideNavTooltip" @focus="showNavTooltip($event, 'Dashboard')" @blur="hideNavTooltip">
                <i class="bi bi-graph-up menu-icon"></i>
              </router-link>
            </li>
            <li
              v-if="Admin || Coordinacion || Asesor"
              class="header-nav-item nav-item"
              @mouseenter="openOriginMenu($event)"
              @mouseleave="scheduleOriginMenuClose"
            >
              <a
                class="header-nav-link nav-link"
                href="#"
                aria-label="Clientes y Solicitudes"
                aria-controls="header-origin-menu"
                :aria-expanded="String(originOpen)"
                :class="{
                  'is-active-module': isModuleActive('originacion'),
                  'is-origin-open': originOpen
                }"
                @click.prevent="toggleOriginMenu($event)"
              >
                <i class="bi bi-person-badge menu-icon"></i>
              </a>
            </li>
            <li class="header-nav-item nav-item">
              <router-link class="header-nav-link nav-link" to="/cartera" aria-label="Cartera" :class="{ 'is-active-module': isModuleActive('cartera') }" @mouseenter="showNavTooltip($event, 'Cartera')" @mouseleave="hideNavTooltip" @focus="showNavTooltip($event, 'Cartera')" @blur="hideNavTooltip">
                <i class="bi bi-wallet-fill menu-icon"></i>
                
              </router-link>
            </li>
            <li
              v-if="cobranzaOptions.length"
              class="header-nav-item nav-item"
              @mouseenter="openCobranzaMenu($event)"
              @mouseleave="scheduleCobranzaMenuClose"
            >
              <a
                class="header-nav-link nav-link"
                href="#"
                aria-label="Cobranza"
                aria-controls="header-cobranza-menu"
                :aria-expanded="String(cobranzaOpen)"
                :class="{
                  'is-active-module': isModuleActive('cobranza'),
                  'is-origin-open': cobranzaOpen
                }"
                @click.prevent="toggleCobranzaMenu($event)"
              >
                <i class="bi bi-cash menu-icon"></i>
              </a>
            </li>
            <!-- Proceso Legal oculto temporalmente.
            <li class="header-nav-item nav-item">
              <router-link class="header-nav-link nav-link" to="/proceso-legal" aria-label="Proceso Legal" :class="{ 'is-active-module': isModuleActive('proceso-legal') }" @mouseenter="showNavTooltip($event, 'Proceso Legal')" @mouseleave="hideNavTooltip" @focus="showNavTooltip($event, 'Proceso Legal')" @blur="hideNavTooltip">
                <i class="bi bi-shield menu-icon"></i>
              </router-link>
            </li>
            -->
            <li v-if="Admin" class="header-nav-item nav-item">
              <router-link class="header-nav-link header-nav-link-whatsapp nav-link" to="/whatsapp" aria-label="Whatsapp" :class="{ 'is-active-module': isModuleActive('whatsapp') }" @mouseenter="showNavTooltip($event, 'Whatsapp')" @mouseleave="hideNavTooltip" @focus="showNavTooltip($event, 'Whatsapp')" @blur="hideNavTooltip">
                <i class="bi bi-whatsapp menu-icon"></i>
              </router-link>
            </li>
            <li
              v-if="configurarOptions.length"
              class="header-nav-item nav-item"
              @mouseenter="openConfigurarMenu($event)"
              @mouseleave="scheduleConfigurarMenuClose"
            >
              <a
                class="header-nav-link nav-link"
                href="#"
                aria-label="Configurar"
                aria-controls="header-configurar-menu"
                :aria-expanded="String(configurarOpen)"
                :class="{
                  'is-active-module': isModuleActive('configurar'),
                  'is-origin-open': configurarOpen
                }"
                @click.prevent="toggleConfigurarMenu($event)"
              >
                <i class="bi bi-gear-fill menu-icon"></i>
              </a>
            </li>
          </ul>
        </div>
        <div
          v-if="originOpen"
          id="header-origin-menu"
          class="header-origin-dropdown"
          :style="originMenuStyle"
          @mouseenter="cancelOriginMenuClose"
          @mouseleave="scheduleOriginMenuClose"
        >
          <div class="header-origin-title">Clientes y Solicitudes</div>
          <router-link
            v-for="option in originOptions"
            :key="option.to"
            class="header-origin-option"
            :to="option.to"
            @click="closeOriginMenu"
          >
            {{ option.label }}
          </router-link>
        </div>
        <div
          v-if="cobranzaOpen"
          id="header-cobranza-menu"
          class="header-origin-dropdown"
          :style="cobranzaMenuStyle"
          @mouseenter="cancelCobranzaMenuClose"
          @mouseleave="scheduleCobranzaMenuClose"
        >
          <div class="header-origin-title">Cobranza</div>
          <router-link
            v-for="option in cobranzaOptions"
            :key="option.to"
            class="header-origin-option"
            :to="option.to"
            @click="closeCobranzaMenu"
          >
            {{ option.label }}
          </router-link>
        </div>
        <div
          v-if="configurarOpen"
          id="header-configurar-menu"
          class="header-origin-dropdown"
          :style="configurarMenuStyle"
          @mouseenter="cancelConfigurarMenuClose"
          @mouseleave="scheduleConfigurarMenuClose"
        >
          <div class="header-origin-title">Configurar</div>
          <router-link
            v-for="option in configurarOptions"
            :key="option.to"
            class="header-origin-option"
            :to="option.to"
            @click="closeConfigurarMenu"
          >
            {{ option.label }}
          </router-link>
        </div>
        <div v-if="navTooltip.visible" class="header-nav-tooltip" :style="navTooltip.style">
          {{ navTooltip.label }}
        </div>
      </div>
      <ul class="navbar-nav navbar-nav-right">

        <li class="nav-item dropdown">
          <!-- <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#"
            data-bs-toggle="dropdown">
            <i class="ti-bell mx-0"></i>
            <span class="count"></span>
          </a>
          <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="notificationDropdown">
            <p class="mb-0 font-weight-normal float-left dropdown-header">Notifications</p>
            <a class="dropdown-item">
              <div class="item-thumbnail">
                <div class="item-icon bg-success">
                  <i class="ti-info-alt mx-0"></i>
                </div>
              </div>
              <div class="item-content">
                <h6 class="font-weight-normal">Application Error</h6>
                <p class="font-weight-light small-text mb-0 text-muted">
                  Just now
                </p>
              </div>
            </a>
            <a class="dropdown-item">
              <div class="item-thumbnail">
                <div class="item-icon bg-warning">
                  <i class="ti-settings mx-0"></i>
                </div>
              </div>
              <div class="item-content">
                <h6 class="font-weight-normal">Configuración</h6>
                <p class="font-weight-light small-text mb-0 text-muted">
                  Private message
                </p>
              </div>
            </a>
            <a class="dropdown-item">
              <div class="item-thumbnail">
                <div class="item-icon bg-info">
                  <i class="ti-user mx-0"></i>
                </div>
              </div>
              <div class="item-content">
                <h6 class="font-weight-normal">New user registration</h6>
                <p class="font-weight-light small-text mb-0 text-muted">
                  2 days ago
                </p>
              </div>
            </a>
          </div> -->
        </li>
        <li class="nav-item nav-profile dropdown">
          <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" id="profileDropdown">
            <img src="../assets/user.png" alt="profile" />
          </a>
          <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
            <router-link class="nav-link" to="/axccAdminSettings">
              <a v-if="this.Admin === true || this.Coordinacion === true" class="dropdown-item">
                <i class="ti-settings text-primary"></i>
                Configuración
              </a>
            </router-link>
            <a class="dropdown-item" href="javascript:void(0);" @click="logout">
              <i class="ti-power-off text-primary"></i>
              Cerrar Sesión
            </a>
          </div>
        </li>
      </ul>
      <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
        @click="activarSidebar()">
        <!-- <span class="ti-view-list"></span> --> 
        <span><i class="fa-solid fa-bars"></i></span>
        <!-- <span><i class="bi bi-list"></i></span> -->
      </button>
    </div>
  </nav>
</template>

<script>
import { store } from './store.js'
import router from './../router/index.js'
import Security from './security'
import 'bootstrap-icons/font/bootstrap-icons.css';

// import notie from 'notie'

export default {
  name: 'Header-App',
  data() {
    return {
      roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Consultor', 'oficinaGeneral'],
      Finanzas: false,
      Admin: false,
      Coordinacion: false,
      Asesor: false,
      Consultor: false,
      oficinaGeneral: false,
      originOpen: false,
      originMenuStyle: {},
      originCloseTimeout: null,
      cobranzaOpen: false,
      cobranzaMenuStyle: {},
      cobranzaCloseTimeout: null,
      configurarOpen: false,
      configurarMenuStyle: {},
      configurarCloseTimeout: null,
      navTooltip: {
        visible: false,
        label: '',
        style: {},
      },
      navbarScrolled: false,
      userRoles: []
    }
  },
  computed: {
    originOptions() {
      const options = [
        { label: 'Clientes', to: '/mostrar-solicitantes' },
      ];

      if (!this.Consultor) {
        options.push({ label: 'Solicitudes', to: '/mostrar-solicitudes' });
      }

      if (this.Admin || this.Finanzas) {
        options.push({ label: 'Otorgar', to: '/mostrar-solicitudes-aceptadas' });
      }

      return options;
    },
    cobranzaOptions() {
      const options = [];

      if (this.Admin || this.Finanzas || this.Consultor) {
        options.push({ label: 'Pagos', to: '/pagos' });
        options.push({ label: 'Seguimiento', to: '/bitacora' });
        options.push({ label: 'Proyeccion', to: '/proyeccion' });
      }

      options.push({ label: 'Recordatorios', to: '/recordatorios' });

      return options;
    },
    configurarOptions() {
      if (!this.Admin && !this.Finanzas) return [];

      const options = [];

      if (this.Admin || this.Finanzas) {
        options.push({ label: 'Productos', to: '/productos' });
      }

      if (this.Admin) {
        options.push(
          { label: 'Gestion de Usuarios', to: '/axccAdminSettings' },
          { label: 'Registro de Actividades', to: '/registro-actividades' },
          { label: 'Bancos', to: '/bancos' },
          { label: 'Sucursales', to: '/sucursales' },
          { label: 'Constitución', to: '/constitucion' }
        );
      }

      return options;
    },
  },
  mounted() {
    this.userRoles = Security.getUserRoles();
    this.roles.forEach(element => {
      if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
        this[element] = true;
      }
    });
    this.restoreSidebarPreference();
    this.handleNavbarScroll();
    window.addEventListener('scroll', this.handleNavbarScroll, { passive: true });
  },
  watch: {
    $route() {
      this.closeOriginMenu();
      this.closeCobranzaMenu();
      this.closeConfigurarMenu();
      this.hideNavTooltip();
    },
  },
  beforeUnmount() {
    this.clearOriginMenuTimeout();
    this.clearCobranzaMenuTimeout();
    this.clearConfigurarMenuTimeout();
    window.removeEventListener('scroll', this.handleNavbarScroll);
  },
  methods: {
    handleNavbarScroll() {
      this.navbarScrolled = window.scrollY > 8;
    },
    isModuleActive(moduleName) {
      const currentPath = this.$route?.path || '/';
      const map = {
        home: ['/', '/home'],
        dashboard: ['/dashboard'],
        originacion: ['/solicitud', '/mostrar-solicitantes', '/mostrar-solicitudes', '/mostrar-solicitudes-aceptadas'],
        cartera: ['/cartera'],
        cobranza: ['/pagos', '/bitacora', '/proyeccion', '/recordatorios'],
        configurar: ['/axccAdminSettings', '/registro-actividades', '/bancos', '/productos', '/producto/nuevo'],
        recordatorios: ['/recordatorios'],
        pagos: ['/pagos'],
        bitacora: ['/bitacora'],
        proyeccion: ['/proyeccion'],
        'proceso-legal': ['/proceso-legal'],
        whatsapp: ['/whatsapp'],
        usuarios: ['/axccAdminSettings'],
        'registro-actividades': ['/registro-actividades'],
        bancos: ['/bancos'],
      };

      if (moduleName === 'home') {
        return currentPath === '/';
      }

      const modulePaths = map[moduleName] || [];
      return modulePaths.some((path) => currentPath.startsWith(path));
    },
    showNavTooltip(event, label) {
      const rect = event.currentTarget.getBoundingClientRect();
      const viewportPadding = 8;
      const maxWidth = Math.min(220, window.innerWidth - (viewportPadding * 2));
      const halfWidth = maxWidth / 2;
      const left = Math.min(
        Math.max(rect.left + rect.width / 2, viewportPadding + halfWidth),
        window.innerWidth - viewportPadding - halfWidth
      );

      this.navTooltip = {
        visible: true,
        label,
        style: {
          top: `${rect.bottom + 8}px`,
          left: `${left}px`,
          maxWidth: `${maxWidth}px`,
        },
      };
    },
    hideNavTooltip() {
      this.navTooltip.visible = false;
    },
    handleHeaderNavScroll() {
      this.closeOriginMenu();
      this.closeCobranzaMenu();
      this.closeConfigurarMenu();
      this.hideNavTooltip();
    },
    toggleOriginMenu(event) {
      if (this.originOpen) {
        this.closeOriginMenu();
        return;
      }

      this.openOriginMenu(event);
    },
    openOriginMenu(event) {
      this.cancelOriginMenuClose();
      this.closeCobranzaMenu();
      this.closeConfigurarMenu();
      this.setOriginMenuPosition(event.currentTarget);
      this.originOpen = true;
    },
    setOriginMenuPosition(target) {
      const rect = target.getBoundingClientRect();
      const menuWidth = 220;
      const maxLeft = Math.max(window.innerWidth - menuWidth - 8, 8);
      const left = Math.min(
        Math.max(rect.left + rect.width / 2 - menuWidth / 2, 8),
        maxLeft
      );

      this.originMenuStyle = {
        top: `${rect.bottom + 8}px`,
        left: `${left}px`,
        minWidth: `${menuWidth}px`,
      };
    },
    scheduleOriginMenuClose() {
      this.clearOriginMenuTimeout();
      this.originCloseTimeout = setTimeout(() => {
        this.originOpen = false;
      }, 140);
    },
    cancelOriginMenuClose() {
      this.clearOriginMenuTimeout();
    },
    clearOriginMenuTimeout() {
      if (this.originCloseTimeout) {
        clearTimeout(this.originCloseTimeout);
        this.originCloseTimeout = null;
      }
    },
    closeOriginMenu() {
      this.clearOriginMenuTimeout();
      this.originOpen = false;
    },
    toggleCobranzaMenu(event) {
      if (this.cobranzaOpen) {
        this.closeCobranzaMenu();
        return;
      }

      this.openCobranzaMenu(event);
    },
    openCobranzaMenu(event) {
      this.cancelCobranzaMenuClose();
      this.closeOriginMenu();
      this.closeConfigurarMenu();
      this.setCobranzaMenuPosition(event.currentTarget);
      this.cobranzaOpen = true;
    },
    setCobranzaMenuPosition(target) {
      const rect = target.getBoundingClientRect();
      const menuWidth = 220;
      const maxLeft = Math.max(window.innerWidth - menuWidth - 8, 8);
      const left = Math.min(
        Math.max(rect.left + rect.width / 2 - menuWidth / 2, 8),
        maxLeft
      );

      this.cobranzaMenuStyle = {
        top: `${rect.bottom + 8}px`,
        left: `${left}px`,
        minWidth: `${menuWidth}px`,
      };
    },
    scheduleCobranzaMenuClose() {
      this.clearCobranzaMenuTimeout();
      this.cobranzaCloseTimeout = setTimeout(() => {
        this.cobranzaOpen = false;
      }, 140);
    },
    cancelCobranzaMenuClose() {
      this.clearCobranzaMenuTimeout();
    },
    clearCobranzaMenuTimeout() {
      if (this.cobranzaCloseTimeout) {
        clearTimeout(this.cobranzaCloseTimeout);
        this.cobranzaCloseTimeout = null;
      }
    },
    closeCobranzaMenu() {
      this.clearCobranzaMenuTimeout();
      this.cobranzaOpen = false;
    },
    toggleConfigurarMenu(event) {
      if (this.configurarOpen) {
        this.closeConfigurarMenu();
        return;
      }

      this.openConfigurarMenu(event);
    },
    openConfigurarMenu(event) {
      this.cancelConfigurarMenuClose();
      this.closeOriginMenu();
      this.closeCobranzaMenu();
      this.setConfigurarMenuPosition(event.currentTarget);
      this.configurarOpen = true;
    },
    setConfigurarMenuPosition(target) {
      const rect = target.getBoundingClientRect();
      const menuWidth = 220;
      const maxLeft = Math.max(window.innerWidth - menuWidth - 8, 8);
      const left = Math.min(
        Math.max(rect.left + rect.width / 2 - menuWidth / 2, 8),
        maxLeft
      );

      this.configurarMenuStyle = {
        top: `${rect.bottom + 8}px`,
        left: `${left}px`,
        minWidth: `${menuWidth}px`,
      };
    },
    scheduleConfigurarMenuClose() {
      this.clearConfigurarMenuTimeout();
      this.configurarCloseTimeout = setTimeout(() => {
        this.configurarOpen = false;
      }, 140);
    },
    cancelConfigurarMenuClose() {
      this.clearConfigurarMenuTimeout();
    },
    clearConfigurarMenuTimeout() {
      if (this.configurarCloseTimeout) {
        clearTimeout(this.configurarCloseTimeout);
        this.configurarCloseTimeout = null;
      }
    },
    closeConfigurarMenu() {
      this.clearConfigurarMenuTimeout();
      this.configurarOpen = false;
    },
    logout() {
      const payload = {
        token: store.token,
      }

      fetch(process.env.VUE_APP_API_URL + "/users/logout", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            console.log(response.message);
          } else {
            Security.clearSessionState();


            // document.cookie = '_site_data=; Path=/; ' +
            // 'SameSite=Strict; Secure; ' +
            // 'Expires=Thu, 01 Jan 1970 00:00:01 GMT;'

            router.push("/");
            location.reload();
            window.location.href = "/";

          }
        })

    },
    activarSidebar() {
      "ENTRA A ACTIVAR SIDEBAR";
      const sidebar = document.getElementById('sidebar');

      if (sidebar) {
        sidebar.classList.toggle('active');
      }


    },
    activarSidebarBody() {
      "ENTRA A ACTIVAR SIDEBAR";
      const body = document.body;

      if (body) {
        body.classList.toggle('sidebar-icon-only');
        localStorage.setItem('sidebar-icon-only', body.classList.contains('sidebar-icon-only') ? '1' : '0');
      }
    },
    restoreSidebarPreference() {
      const body = document.body;
      if (!body) return;

      if (window.matchMedia('(min-width: 992px)').matches) {
        body.classList.remove('sidebar-icon-only');
        return;
      }

      const savedValue = localStorage.getItem('sidebar-icon-only');
      if (savedValue === null) return;

      if (savedValue === '1') {
        body.classList.add('sidebar-icon-only');
      } else {
        body.classList.remove('sidebar-icon-only');
      }
    }

  }
}
</script>

<style>
.navbar-toggler {
  margin-top: 2px;
}

.navbar-blur-layer {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  opacity: 0;
  background-color: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  transition: opacity 0.2s ease;
}

.navbar.navbar-scrolled .navbar-blur-layer {
  opacity: 1;
}

.navbar.navbar-scrolled .navbar-brand-wrapper,
.navbar.navbar-scrolled .navbar-menu-wrapper {
  background-color: transparent !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.navbar.navbar-scrolled .header-nav-shell {
  background-color: #192230;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.navbar .navbar-brand-wrapper,
.navbar .navbar-menu-wrapper > .navbar-nav,
.navbar .navbar-menu-wrapper > .navbar-toggler,
.navbar-center-message {
  position: relative;
  z-index: 2;
}

.desktop-sidebar-toggler {
  display: none !important;
}

.navbar-toggler span i {
  font-size: 2rem;
}

.navbar-toggler span i:active {
  /* font-size: 1.8rem; */
  color: #ffbc58;
}

.navbar-toggler span i:hover {
  /* font-size: 1.8rem; */
  color: #EC9F2D;
}

.navbar-center-message {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  padding: 0 12px;
}

.header-nav-shell {
  width: auto;
  max-width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 10px;
  background-color: #192230;
  padding: 4px 6px;
}

.header-top-nav {
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin: 0;
  padding: 0 2px 3px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
  -webkit-overflow-scrolling: touch;
}

.header-top-nav::-webkit-scrollbar {
  height: 3px;
}

.header-top-nav::-webkit-scrollbar-track {
  background: transparent;
}

.header-top-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.16);
  border-radius: 8px;
}

.header-top-nav:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.26);
}

.header-nav-item {
  flex: 0 0 auto;
  margin-inline: 5px;
  list-style: none;
}

.header-nav-link {
  width: 38px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  color: #f5f5f5;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.header-nav-link:hover,
.header-nav-link:focus,
.header-nav-link:active,
.header-nav-link.is-origin-open {
  background-color: #263247;
  color: #ffffff;
  outline: none;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.header-nav-link.router-link-active,
.header-nav-link.router-link-exact-active,
.header-nav-link.is-active-module,
.header-nav-link.is-active-module:hover,
.header-nav-link.is-active-module:focus,
.header-nav-link.is-active-module:active {
  background-color: #192230;
  color: #F9B233;
  border-bottom: 0;
  outline: none;
  box-shadow: inset 0 0 0 1px rgba(249, 178, 51, 0.22);
}

.header-nav-link .menu-icon {
  color: inherit;
  font-size: 18px;
  
  line-height: 1;
}

.header-nav-link.is-active-module .menu-icon {
  color: #F9B233;
}

.header-nav-link-whatsapp,
.header-nav-link-whatsapp .menu-icon {
  color: rgb(0, 186, 0);
}

.header-nav-link-whatsapp:hover,
.header-nav-link-whatsapp.is-active-module {
  background-color: #102615;
  color: green;
}

.header-nav-tooltip {
  position: fixed;
  z-index: 1200;
  transform: translateX(-50%);
  padding: 7px 10px;
  border-radius: 8px;
  background-color: #1f1f1f;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  overflow-wrap: break-word;
  pointer-events: none;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
}

.header-origin-dropdown {
  position: fixed;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background-color: #192230;
  box-shadow: 0 14px 30px rgba(25, 34, 48, 0.34);
}

.header-origin-title {
  color: #F9B233;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  padding: 6px 8px 4px;
}

.header-origin-option {
  color: #ffffff;
  text-decoration: none;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.2;
}

.header-origin-option:hover {
  background-color: #263247;
  color: #ffffff;
}

.header-origin-option:focus,
.header-origin-option:active,
.header-origin-option.router-link-active,
.header-origin-option.router-link-exact-active {
  background-color: #111827;
  color: #F9B233;
  outline: none;
}

@media (max-width: 991px) {
  .navbar-center-message {
    display: none;
  }
}

@media (min-width: 992px) {
  .navbar .navbar-brand-wrapper,
  .navbar .navbar-menu-wrapper .navbar-nav-right {
    position: relative;
    z-index: 3;
  }

  .navbar .navbar-menu-wrapper {
    justify-content: flex-end !important;
  }

  .navbar-center-message {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 2;
    width: min(760px, calc(100vw - 340px));
    margin: 0 auto;
    padding: 0;
  }

  .navbar-center-message .header-nav-shell {
    width: 100%;
  }

  .page-body-wrapper > .sidebar {
    display: none !important;
  }

  .page-body-wrapper > .main-panel,
  .sidebar-icon-only .page-body-wrapper > .main-panel {
    width: 100% !important;
  }
}
</style>
